import script from "./advices.vue?vue&type=script&setup=true&lang=js"
export * from "./advices.vue?vue&type=script&setup=true&lang=js"

import "./advices.vue?vue&type=style&index=0&id=59dfb60b&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59dfb60b"]])

export default __exports__